import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/pixel';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const clickGuard = useRef(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = () => {
    if (clickGuard.current) return;
    clickGuard.current = true;
    setTimeout(() => clickGuard.current = false, 1500);
    trackInitiateCheckout();
  };
  return <AnimatePresence data-id="element-120">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="hidden md:flex fixed bottom-6 right-6 z-40 flex-col items-end gap-2" data-id="element-121">
          {/* Pulse halo */}
          <div className="relative" data-id="element-122">
            <span aria-hidden className="absolute inset-0 rounded-full bg-blue-500/40 animate-ping pointer-events-none" style={{
          animationDuration: '2.5s'
        }} data-id="element-123" />
            <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" onClick={handleClick} className="relative inline-flex items-center gap-2.5 px-6 py-4 text-base font-bold text-white bg-blue-600 rounded-full shadow-[0_10px_30px_-5px_rgba(37,99,235,0.6)] hover:bg-blue-500 hover:shadow-[0_15px_40px_-5px_rgba(37,99,235,0.8)] hover:scale-[1.03] transition-all" data-id="element-124">
              <ShoppingBag className="w-5 h-5" data-id="element-125" />
              Comprar guía ahora
            </a>
          </div>
          <span className="text-xs text-zinc-500 font-medium pr-2" data-id="element-126">
            Acceso inmediato
          </span>
        </motion.div>}
    </AnimatePresence>;
}